<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="bookerinitials.icon" class="mr-1"></i>
            <span>{{ bookerinitials.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                    :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Initials" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="initials" :debounce="bookerinitials.debounce"
                      placeholder="Initials"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!initials" @click="initials = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="bookerinitials.debounce"
                      placeholder="Name"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description" @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="bookerinitials" :icon="bookerinitials.icon"
            :busy="bookerinitials.busy" :toolbarlibrary="bookerinitials.toolbarlibrary" :tools="bookerinitials.tools"
            :badges="bookerinitials.badges" :fields="bookerinitials.fields" :items="bookerinitials.items"
            :limit="bookerinitials.limit" :downloaded="bookerinitials.downloaded" :showpages="true" :offset="bookerinitials.offset" :page="bookerinitials.page" @load="bookerinitials_load"
            @click="bookerinitials_click" @changed="bookerinitials_click('save', $event)" @select="bookerinitials_select" :unsortable="false">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="bookerinitials.selected" :config="cconfig"
          @discard="bookerinitials_click('discard')" @go="bookerinitials_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
                    <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
                        <i class="fa fa-cogs mr-2"></i>Setup All
                    </b-button>
                </div>     
      </b-card-footer>

    </b-card>

  </div>
</template>


<script>
import gql from "graphql-tag";

import BookerInitialEdit from "./Components/Setup_BookerInitialEdit";

export default {
  name: "BookerInitial",
  components: { BookerInitialEdit },
  watch: {
    async slac() {
      await this.bookerinitials_load(0);
    },
    async initials() {
      await this.bookerinitials_load(0);
    },
    async description() {
      await this.bookerinitials_load(0);
    },
  },
  data() {
    return {
      name: null,
      slac: [],
      initials: null,
      description: null,
      bookerinitials: {
        title: "Booker Initials",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,clipboard,add,edit,notes,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right w-50px",
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "initials",
            label: "Initials",
            sortable: true,
          },
          {
            key: "surname",
            label: "Surname",
            sortable: true,
            class: "uppercase"
          },
          {
            key: "firstname",
            label: "First Name",
            sortable: true,
            class: "uppercase"
          },
          {
            key: "title",
            label: "Title",
            sortable: true,
            class: "uppercase"
          },
          {
            key: "description",
            label: "Display Name",
            sortable: true,
            class: "uppercase"
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },

          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.bookerinitials_load();
  },

  methods: {
    accessdenied() {
      this.bookerinitials.denied = [];
      if (!this.user.permissions.includes("setup_bookerinitials.admin")) {
        this.bookerinitials.denied.push("deleteconfirm");   
      }
      if (!this.user.permissions.includes("setup_bookerinitials.admin")) {
        this.bookerinitials.denied.push("add");
        this.bookerinitials.denied.push("save");
      } 

    },

    async bookerinitials_load(offset, limit, page) {
      let state = this.bookerinitials;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        initials: this.initials,
        description: this.description,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_bookerinitials(
              $limit: Int
              $offset: Int
              $slac: String
              $initials: String
              $description: String
              $dateformat: String
            ) {
              setup_bookerinitials(
                limit: $limit
                offset: $offset
                slac: $slac
                initials: $initials
                description: $description
                dateformat: $dateformat
              ) {
                id
                slac
                initials
                firstname
                surname
                title
                description
                notes
                rows
                updated_at
                  updated_by
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
       
        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_bookerinitials
        } else {
          state.items = response.data.setup_bookerinitials;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async bookerinitials_click(a, ss) {

      let state = this.bookerinitials;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.bookerinitials_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          await this.bookerinitials_load();
          break;
        case "go":
          this.component = null;
          await this.bookerinitials_load();
          break;
        case "add":
        case "edit":
          this.component = "BookerInitialEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async bookerinitials_select(ss, tools) {

      let state = this.bookerinitials;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download","clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {
      // let requirement = { ...this.requirement_bookerinitial };


      // let requirements = "";
      // for (var prop in requirement) {
      //   if (this.item[prop] == null) {
      //     requirements += requirement[prop] + ", ";
      //     // break;
      //   }
      // }
      // if (requirements.length > 0) {
      //   this.message =
      //     "<span class='text-danger'>" +
      //     requirements.slice(0, -1) +
      //     " required field(s). </span>";
      //   return;
      // }
      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_bookerinitials_save(
              $rows: [setup_bookerinitials_input]
              $dateformat: String
            ) {
              setup_bookerinitials_save(rows: $rows, dateformat: $dateformat) {
                id
                slac
                initials
                description
                firstname
                surname
                title
                notes
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_bookerinitials_delete(
              $rows: [setup_bookerinitials_input]
            ) {
              setup_bookerinitials_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.bookerinitials_load(0);
    },
  },
};
</script>

<style></style>